import type { EditorDocument, ImportReport } from '../core/model';

export interface CodecProgress {
  phase: 'validating' | 'decoding' | 'converting' | 'serializing';
  progress: number;
  message: string;
}

export interface CodecContext {
  signal?: AbortSignal;
  onProgress?: (progress: CodecProgress) => void;
}

export interface CodecReadResult {
  document: EditorDocument;
  report?: ImportReport;
}

export interface DocumentCodec {
  readonly id: string;
  readonly label: string;
  canRead(file: File): boolean;
  read(file: File, context?: CodecContext): Promise<CodecReadResult>;
}

export function throwIfAborted(signal?: AbortSignal): void {
  if (signal?.aborted) throw new DOMException('Operation cancelled.', 'AbortError');
}
